"use client";
import RightDrawer from "@/components/ui/drawer/RightDrawer";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { GrHelpBook } from "react-icons/gr";

export default function HelpButton({
  children,
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const hasSeenHelp = localStorage
      .getItem("help")
      ?.split(",")
      ?.includes(pathname);

    if (!hasSeenHelp) {
      setOpen(true);
      localStorage.setItem(
        "help",
        `${localStorage.getItem("help")},${pathname}`
      );
    }
  }, [pathname]);

  return (
    <div>
      <button
        onClick={() => setOpen(true)}
        title="Ayuda"
        disabled={!children}
        className="disabled:opacity-50 sticky bottom-1 right-1"
      >
        <GrHelpBook className="relative top-0.5 h-5 w-auto" />
      </button>
      <RightDrawer open={open} setOpen={setOpen}>
        <div className="p-4">
          <h2 className="pageSubtitle mb-6">Ayuda</h2>
          {children}
        </div>
      </RightDrawer>
    </div>
  );
}
